<template>
  <div class="experiments">
    <v-row v-if="current.user_level=='ADMIN'" class="mt-5">
      <v-col>
      <h6 class="mx-3">{{ $t("manage.by_admin.bookings.header") }}</h6>
      </v-col>
    </v-row>
    <v-row v-if="current.user_level=='ADMIN'">
      <v-col class="d-flex justify-start">
        <v-btn class="mx-3" @click="getAllCurrentBookings()">
          {{ $t("manage.by_admin.bookings.btn_reload") }}
          <v-icon>mdi-reload</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-data-table
      dense
      :locale="localeTranslate()"
      :headers="tableHeader()"
      :items="api.bookings"
      item-key="id"
      :sort-by="['start_at']"
      :sort-desc="[true]"
      multi-sort
      :items-per-page="-1"
    >
    </v-data-table>
    <v-row v-if="current.user_level=='ADMIN'">
      <v-col class="d-flex justify-start">
        <v-btn class="mx-3" @click="getAllCurrentBookings()">
          {{ $t("manage.by_admin.bookings.btn_reload") }}
          <v-icon>mdi-reload</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { api_management } from "@/services/iot/api_management";
const apiManagement = new api_management(process.env.VUE_APP_BASE_URL);
export default {
  name: "AllCurrentBookings",
  data: function () {
    return {
      assignCheckbox: false,
      menu: false,
      current:{
        school_id: null,
        username: null,
        user_level: "USER",
        auth_token: null,
      },
      api: {
        bookings: [],
      },
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Slot', value: 'slot'},
        { text: 'School ID', value: 'school_id' },
        { text: 'Experiment Set', value: 'experiment_set' },
        { text: 'Start', value: 'start_at' },
        { text: 'End', value: 'end_at' },
        { text: 'Status', value: 'status' },
        { text: 'Username', value: 'username' },
        { text: 'User Group', value: 'user_group' },
        { text: 'Has Entered', value: 'has_entered' },
      ],
      headers_chi: [
        { text: 'ID', value: 'id' },
        { text: '時段', value: 'slot'},
        { text: '學校ID', value: 'school_id' },
        { text: '實驗組', value: 'experiment_set' },
        { text: '開始', value: 'start_at' },
        { text: '結束', value: 'end_at' },
        { text: '狀態', value: 'status' },
        { text: '用戶', value: 'username' },
        { text: '用戶組', value: 'user_group' },
        { text: '曾經進入', value: 'has_entered' },
      ],
    };
  },
  mounted: function () {
    var self = this;
    self.current.school_id = self.$route.params.school_id;
    self.current.username = self.$store.state.user.username;
    self.current.user_level = self.$store.state.user.user_level;
    self.current.auth_token = self.$store.state.user.auth_token;
    self.getAllCurrentBookings();
  },  
  methods: {
    localeTranslate(){
      var self = this;
      if(self.$i18n.locale=='tc') return 'zh-tw';
      else return 'en';
    },
    tableHeader(){
      var self = this;
      if(self.$i18n.locale=='tc')
        return self.headers_chi;
      else
        return self.headers;
    },
    getAllCurrentBookings(){
      var self = this;
      apiManagement.getAllCurrentBookings()
      .then((response) => {
          self.api.bookings = response.bookings;
      });
    },
  },
};
</script>

<style scoped lang="scss">
</style>